import { defineStore } from 'pinia';
import { services, getHeader } from '@/assets/js/config.js';
import axios from 'axios'
import { useHttpStore } from './httpStore';

export const useCustomerStore = defineStore('customer', {
	state: () => ({
		activeCustomer: {}, //MERGE OF INV & IM2U CUSTOMER
		activeCustomerInv: {},
		activeCustomerIm2u: {},
		activeLoanEC: {},
		activeLoanECCcriss: { data: [], summary: {} },
		activeLoanECNonCcriss: { data: [], summary: {} },
		activeLoanECOtherPayment: { data: [], summary: {} },
		activeLoanECRepaymentSrc: { data: [], summary: {} },
		activeFormLoanEc: {
			loan_type_id: '',
			selectedLoanType: {},
			loan_tenure: 0,
			loan_tenure_period: '',
			loan_tenure_year:0,
			interest_rate: 0,
			total_amount_paid: 0,
			total_interest: 0,
			stamp_duty:0,
			stamping_fee_prc:0,
			stakeholder_sum:0,
			stakeholder_mth:0,
			vet_fac_prc:0,
			vet_fac_sst:8,
			vet_fac_amt:0,
			legal_fees:0,
			legal_base_amt:0,
			legal_sst_prc:0,
			debt_consolidation_amount:0,
			bal_disbursement_amount:0,
			moratorium_eligible: false,
			moratorium_tenure: 0,
			moratorium_eligible_rate: 0,
			moratorium_installment: 0,
			moratorium_start_period: 1,
			moratorium_tenure_period: 'Months',
			flexi_loan_eligible: false,
			flexi_loan_amount: 0,
			flexi_interest_rate: 0,
			flexi_loan_status:0,
			flexi_loan_tenure:9,
			flexi_eligible_limit:0,
			installment_amount: 0,
			installment_eligible: 0,
			installment_available: 0,
			adv_payment_amount: 0,
			loan_amount: 0,
			repayment_loan_amount:0,
			net_income: 0,
			net_dispose_income: 0,
			final_installment:0,
			ccris_commitment: 0,
			ccris_settlement: 0,
			non_ccris_settlement: 0,
			other_payment_outstanding:0,
			other_payment_settlement: 0,
			loanEligibleList:[],
			ccrisItemsSettleList:[],
			nonCcrisItemsSettleList:[],
			othPaymentItemsList:[],
			repaymentItemsList:[],
			loanTableList:[],
			flexiLoanTableList:[],
		}
	}),
	getters: {
		// getActiveCustomerInv() {
		// 	this.activeCustomerInv = localStorage.getItem('customer.inv.detail') ? JSON.parse(localStorage.getItem('customer.inv.detail')) : {};
		// 	return this.activeCustomerInv;
		// },
		// getActiveCustomerIm2u() {
		// 	this.activeCustomerIm2u = localStorage.getItem('customer.im2u.detail') ? JSON.parse(localStorage.getItem('customer.im2u.detail')) : {};
		// 	return this.activeCustomerIm2u;
		// },
		getActiveCustomer() {
			let custInv = this.activeCustomerInv;
			let custIm2u = this.activeCustomerIm2u;
			if (!_gHlp.isEmpty(custIm2u) && !_gHlp.isEmpty(custInv)) {
				custIm2u['id'] = custInv.id;
				custIm2u['im2u_id'] = custInv.im2u_id;
				custIm2u['sas_im2u_id'] = custInv.sas_im2u_id;
				custIm2u['psal_id'] = custInv.psal_id;
				custIm2u['credit_report_id'] = custInv.credit_report_id;
				custIm2u['message_group_bundle_key'] = custInv.message_group_bundle_key;
				this.activeCustomer = custIm2u;
			} else {
				this.activeCustomer = {};
			}
			return this.activeCustomer;
		}
	},
	actions: {
		clearCustomerState(){
			this.activeCustomer = {}
			this.activeCustomerInv = {}
			this.activeCustomerIm2u = {}
		},
		clearLoanEcState(){
			this.activeLoanEC = {}
			this.activeLoanECCcriss = { data: [], summary: {} },
			this.activeLoanECNonCcriss = { data: [], summary: {} },
			this.activeLoanECOtherPayment = { data: [], summary: {} },
			this.activeLoanECRepaymentSrc = { data: [], summary: {} },
			this.activeFormLoanEc = {
				loan_type_id: '',
				selectedLoanType: {},
				loan_tenure: 0,
				loan_tenure_period: '',
				loan_tenure_year:0,
				interest_rate: 0,
				total_amount_paid: 0,
				total_interest: 0,
				stamp_duty:0,
				stamping_fee_prc:0,
				stakeholder_sum:0,
				stakeholder_mth:0,
				vet_fac_prc:0,
				vet_fac_sst:8,
				vet_fac_amt:0,
				legal_fees:0,
				legal_base_amt:0,
				legal_sst_prc:0,
				debt_consolidation_amount:0,
				bal_disbursement_amount:0,
				moratorium_eligible: false,
				moratorium_tenure: 0,
				moratorium_eligible_rate: 0,
				moratorium_installment: 0,
				moratorium_start_period: 1,
				moratorium_tenure_period: 'Months',
				flexi_loan_eligible: false,
				flexi_loan_amount: 0,
				flexi_interest_rate: 0,
				flexi_loan_status:0,
				flexi_loan_tenure:9,
				flexi_eligible_limit:0,
				installment_amount: 0,
				installment_eligible: 0,
				installment_available: 0,
				adv_payment_amount: 0,
				loan_amount: 0,
				repayment_loan_amount:0,
				net_income: 0,
				net_dispose_income: 0,
				final_installment:0,
				ccris_commitment: 0,
				ccris_settlement: 0,
				non_ccris_settlement: 0,
				other_payment_outstanding:0,
				other_payment_settlement: 0,
				loanEligibleList:[],
				ccrisItemsSettleList:[],
				nonCcrisItemsSettleList:[],
				othPaymentItemsList:[],
				repaymentItemsList:[],
				loanTableList:[],
				flexiLoanTableList:[],
			}
		},
		/**CUSTOMERS**/
		getCustomerInvList(params, fetchCustomer = false) {
			const httpStore = useHttpStore();
			return new Promise((resolve, reject) => {
				httpStore.get(`${services.invinity}customer`, params).then((resp) => {
					httpStore.convertPaginationKeys(resp.data);

					// if (fetchCustomer && !_gHlp.isEmpty(resp.data.data)) {
					// 	let im2u_ids = resp.data.data.map(customer => customer.im2u_id);
					// 	params = {
					// 		full: 'simple',
					// 		customer_id: im2u_ids.join(',')
					// 	}
					// 	this.getCustomerIm2uList(params);
					// }

					resolve(resp.data);
				}).catch(err => {
					reject(err)
				})
			});
		},

		getCustomerIm2uList(params) {
			const httpStore = useHttpStore();
			return new Promise((resolve, reject) => {
				httpStore.get(`${services.customer}customers`, params).then((resp) => {
					resolve(resp.data.data.data);
				})
			});
		},

		getCustomerInv(id) {
			// _gNotif.cLog(inviCust);
			const httpStore = useHttpStore();
			if (_gHlp.isEmpty(id)) {
				id = this.activeCustomerInv.id
			}
			return new Promise((resolve, reject) => {
				httpStore.get(`${services.invinity}customer/${id}`).then((resp) => {
					this.activeCustomerInv = resp.data.data
					resolve(resp.data.data);
				})
			});
		},

		getCustomerIm2u(customer_id) {
			const httpStore = useHttpStore();
			if (_gHlp.isEmpty(customer_id)) {
				customer_id = this.activeCustomerIm2u.customer_id
			}
			return new Promise((resolve, reject) => {
				httpStore.get(`${services.customer}customers/${customer_id}?full=yes`).then((resp) => {
					httpStore.convertPaginationKeys(resp.data);
					this.activeCustomerIm2u = resp.data.data;
					this.getActiveCustomer
					resolve(resp.data);
				})
			});
		},
		getCustomerStatus() {
			const httpStore = useHttpStore();
			return new Promise((resolve, reject) => {
				httpStore.get(`${services.customer}customer/statuses`).then((resp) => {
					let response = _gHlp.getValue(resp, 'data.data', []);
					const listStatus = response.filter((status) => status.group == "sub" ? status : "").sort(function(a, b) {
							if(a.parent_status && b.parent_status){
									if (a.parent_status < b.parent_status) {
											return -1;
									}
									if (a.parent_status > b.parent_status) {
											return 1;
									}
							}
							return 0;
					})
					resolve(listStatus);
				}).catch(err => {
					reject(err);
				});
			});
		},
		getCustomer(id = null) {
			const httpStore = useHttpStore();
			if (_gHlp.isEmpty(id)) {
				id = this.getActiveCustomer.id
			}
			return new Promise((resolve, reject) => {
				if (_gHlp.isEmpty(id)) {
					reject(false);
				} else {
					this.getCustomerInv(id).then((resp) => {
						this.getCustomerIm2u(resp.im2u_id).then((resp2) => {
							this.getActiveCustomer
							resolve(this.activeCustomer)
						}).catch(err => {
							reject(err)
						});
					}).catch(err => {
						reject(err)
					});
				}
			});
		},

		createCustomer(data) {
			const httpStore = useHttpStore();
			return new Promise((resolve, reject) => {
				const msData = {
					name: data.name,
					nric: data.nric,
					contact_no: data.phone_no,
					is_test: 1,
					is_foreigner: 0,
				};
				//create data in microservices
				httpStore.post(`${services.customer}customers`, msData).then((msResp) => {
					//create data in invinity
					data.im2u_id = msResp.data?.data?.customer_id;
					this.activeCustomerIm2u = msResp.data.data;
					this.activeCustomerIm2u.im2u_id = this.activeCustomerIm2u.customer_id;
					httpStore.post(`${services.invinity}customer`, data).then((resp) => {
						this.activeCustomerInv = resp.data.data;
						this.activeCustomerIm2u.id = this.activeCustomerInv.id;
						this.getActiveCustomer
						const mainIncomes = this.activeCustomerIm2u.incomes.main;
						const params = {
							gross_income: mainIncomes.gross_income,
							net_income: mainIncomes.net_income,
							balance_commitment: mainIncomes.total_commitment,
							dsr: mainIncomes.dsr
						};
						this.createLoanEC(params, this.activeCustomerInv.id).then(resp => {
							resolve(resp.data);
						});
					});
				}).catch(err => {
					_gNotif.cLog(err);
				});
			});
		},

		updateCustomer(id, params) {
			const httpStore = useHttpStore();
			return new Promise((resolve, reject) => {
				httpStore.put(`${services.invinity}customer/${id}`, params).then((resp) => {
					resolve(resp.data);
				})
			});
		},

		updateCustomerGeneralInfo(id, data) {
			const httpStore = useHttpStore();
			return new Promise((resolve, reject) => {
				httpStore.put(`${services.customer}customers/${id}`, data).then((resp) => {
					this.updateCustomer(this.activeCustomer.id, {
						name: data.name,
						nric: data.nric,
						company_registration_no: data.company_registration_no,
						phone_no: data.contact_no,
					});
					resolve(resp.data);
				});
			});
		},

		updateCustomerLocation(id, data) {
			const httpStore = useHttpStore();
			return new Promise((resolve, reject) => {
				httpStore.post(`${services.customer}customer/${id}/locations`, data).then((resp) => {
					resolve(resp.data);
				});
			});
		},

		addBankDetail(data, id = this.activeCustomer.im2u_id) {
			const httpStore = useHttpStore();
			return new Promise((resolve, reject) => {
				httpStore.post(`${services.customer}customer/${id}/banks`, data).then((resp) => {
					resolve(resp.data);
				}).catch(err => {
					_gNotif.cLog(err);
				});
			});
		},

		updateBankDetail(bankId, data, customerId = this.activeCustomer.im2u_id) {
			const httpStore = useHttpStore();
			return new Promise((resolve, reject) => {
				httpStore.put(`${services.customer}customer/${customerId}/banks/${bankId}`, data).then((resp) => {
					resolve(resp.data);
				}).catch(err => {
					_gNotif.cLog(err);
				});
			});
		},

		updateEmployments(data, customerId = this.activeCustomer.im2u_id) {
			const httpStore = useHttpStore();
			return new Promise((resolve, reject) => {
				httpStore.post(`${services.customer}customer/${customerId}/companies`, data).then((resp) => {
					resolve(resp.data);
				}).catch(err => {
					_gNotif.cLog(err);
				});
			});
		},

		addSpouse(data, id = this.activeCustomer.im2u_id) {
			const httpStore = useHttpStore();
			return new Promise((resolve, reject) => {
				httpStore.post(`${services.customer}customer/${id}/spouses`, data).then((resp) => {
					resolve(resp.data);
				}).catch(err => {
					_gNotif.cLog(err);
				});
			});
		},

		updateSpouse(id, data, customerId = this.activeCustomer.im2u_id) {
			const httpStore = useHttpStore();
			return new Promise((resolve, reject) => {
				httpStore.put(`${services.customer}customer/${customerId}/spouses/${id}`, data).then((resp) => {
					resolve(resp.data);
				}).catch(err => {
					_gNotif.cLog(err);
				});
			});
		},

		addEmergency(data, id = this.activeCustomer.im2u_id) {
			const httpStore = useHttpStore();
			return new Promise((resolve, reject) => {
				httpStore.post(`${services.customer}customer/${id}/emergencies`, data).then((resp) => {
					resolve(resp.data);
				}).catch(err => {
					_gNotif.cLog(err);
				});
			});
		},

		updateEmergency(id, data, customerId = this.activeCustomer.im2u_id) {
			const httpStore = useHttpStore();
			return new Promise((resolve, reject) => {
				httpStore.put(`${services.customer}customer/${customerId}/emergencies/${id}`, data).then((resp) => {
					resolve(resp.data);
				}).catch(err => {
					_gNotif.cLog(err);
				});
			});
		},

		updateIncome(data, customerId = this.activeCustomer.im2u_id) {
			const httpStore = useHttpStore();
			return new Promise((resolve, reject) => {
				httpStore.put(`${services.customer}customer/${customerId}/income.all`, data).then((resp) => {
					resolve(resp.data);
				}).catch(err => {
					_gNotif.cLog(err);
					reject(err);
				});
			});
		},

		updateIncomeMain(id, data, customerId = this.activeCustomer.im2u_id) {
			const httpStore = useHttpStore();
			return new Promise((resolve, reject) => {
				httpStore.put(`${services.customer}customer/${customerId}/income/main/${id}`, data).then((resp) => {
					resolve(resp.data);
				}).catch(err => {
					_gNotif.cLog(err);
					reject(err);
				});
			});
		},

		updateIncomeBonuses(data, customerId = this.activeCustomer.im2u_id) {
			const httpStore = useHttpStore();
			return new Promise((resolve, reject) => {
				httpStore.put(`${services.customer}customer/${customerId}/income/bonuses`, data).then((resp) => {
					resolve(resp.data);
				}).catch(err => {
					_gNotif.cLog(err);
					reject(err);
				});
			});
		},

		updateIncomeRentals(data, customerId = this.activeCustomer.im2u_id) {
			const httpStore = useHttpStore();
			return new Promise((resolve, reject) => {
				httpStore.put(`${services.customer}customer/${customerId}/income/rentals`, data).then((resp) => {
					resolve(resp.data);
				}).catch(err => {
					_gNotif.cLog(err);
					reject(err);
				});
			});
		},

		updateIncomeOthers(data, customerId = this.activeCustomer.im2u_id) {
			const httpStore = useHttpStore();
			return new Promise((resolve, reject) => {
				httpStore.put(`${services.customer}customer/${customerId}/income/others`, data).then((resp) => {
					resolve(resp.data);
				}).catch(err => {
					_gNotif.cLog(err);
					reject(err);
				});
			});
		},

		getDocTypes() {
			const httpStore = useHttpStore();
			return new Promise((resolve, reject) => {
				httpStore.get(`${services.attachment}attachment/categories`).then((resp) => {
					resolve(resp.data);
				}).catch(err => {
					_gNotif.cLog(err);
					reject(err);
				});
			});
		},

		getCustDocs(ownerType = 'proposal', customerId = this.activeCustomer.im2u_id) {
			const httpStore = useHttpStore();
			const params = {
				owner_id: customerId,
				owner_type: ownerType,
			};
			return new Promise((resolve, reject) => {
				httpStore.get(`${services.customer}customer/${customerId}/attachments`, params).then((resp) => {
					resolve(resp.data);
				}).catch(err => {
					// _gNotif.cLog(err);
					reject(err);
				});
			});
		},

		downloadCustDoc(docId, customerId = this.activeCustomer.im2u_id) {
			const httpStore = useHttpStore();
			return new Promise((resolve, reject) => {
				httpStore.get(`${services.customer}customer/${customerId}/attachments/${docId}`).then((resp) => {
					resolve(resp.data);
				}).catch(err => {
					_gNotif.cLog(err);
					reject(err);
				});
			});
		},

		uploadCustDoc(owner_type, params, customerId = this.activeCustomer.im2u_id) {
			const httpStore = useHttpStore();
			return new Promise((resolve, reject) => {
				params.owner_type = owner_type;
				params.owner_id = customerId;
				httpStore.post(`${services.customer}customer/${customerId}/attachments`, params).then((resp) => {
					resolve(resp.data);
				}).catch(err => {
					_gNotif.cLog(err);
					reject(err);
				});
			});
		},

		removeCustDoc(params, customerId = this.activeCustomer.im2u_id) {
			const httpStore = useHttpStore();
			return new Promise((resolve, reject) => {
				httpStore.delete(`${services.customer}customer/${customerId}/attachments/${params.attachment_id}`, params).then((resp) => {
					resolve(resp.data);
				}).catch(err => {
					_gNotif.cLog(err);
					reject(err);
				});
			});
		},

		getUserCanAccess(id) {
			const httpStore = useHttpStore();
			return new Promise((resolve, reject) => {
				httpStore.get(`${services.customer}get-user-can-access-list/${id}`).then((resp) => {
					resolve(resp.data.data);
				})
			});
		},

		/**SYNC TRIGGER **/
		syncFromSas(psal_id = null) {
			if (_gHlp.isEmpty(psal_id)) cust_id = this.getActiveCustomer.psal_id;

			const httpStore = useHttpStore();
			return new Promise((resolve, reject) => {
				if (!_gHlp.isEmpty(psal_id)) {
					httpStore.post(`${services.invinity}sync-sas/${psal_id}`).then((resp) => {
						this.activeLoanEC = resp.data.data;
						resolve(resp.data.data);
					}).catch(err => {
						_gNotif.cLog(err);
						reject(err);
					});
				} else {
					reject(null);
				}
			});
		},

		/**LOAN ELIGIBLE CALCULATOR**/
		getLoanEcList(params) {
			const httpStore = useHttpStore();
			return new Promise((resolve, reject) => {
				httpStore.get(`${services.invinity}loan-ec`, params).then((resp) => {
					httpStore.convertPaginationKeys(resp.data);
					resolve(resp.data);
				})
			});
		},
		/*=DETAILS=*/
		getLoanEC(loanEcId = null,customerId = null) {
			const httpStore = useHttpStore();
			return new Promise((resolve, reject) => {
				if(_gHlp.isEmpty(customerId)) customerId = this.activeCustomer.id;
				const params = !_gHlp.isEmpty(loanEcId) ? {loan_ec_id: loanEcId} : {};

				httpStore.get(`${services.invinity}loan-ec/customer/${customerId}`,params).then((resp) => {
					this.activeLoanEC = resp.data.data;
					resolve(resp.data.data);
				}).catch(err => {
					_gNotif.cLog(err);
					reject(err);
				});
			});
		},

		createLoanEC(params, customer_id = this.activeCustomer.id) {
			const data = {
				...params,
				customer_id
			}
			const httpStore = useHttpStore();
			return new Promise((resolve, reject) => {
				httpStore.post(`${services.invinity}loan-ec`, data).then((resp) => {
					this.activeLoanEC = resp.data;
					resolve(resp.data);
				}).catch(err => {
					_gNotif.cLog(err);
					reject(err);
				});
			});
		},

		createLoanEcByExisCust(inv_id,im2u_id) {
			const httpStore = useHttpStore();
			return new Promise((resolve, reject) => {
				httpStore.get(`${services.customer}customers/${im2u_id}?full=yes`).then((resp) => {
					const mainIncomes = _gHlp.getValue(resp,'data.data.incomes.main');
					const params = {
						gross_income: mainIncomes.gross_income,
						net_income: mainIncomes.net_income,
						balance_commitment: mainIncomes.total_commitment,
						dsr: mainIncomes.dsr
					};
					this.createLoanEC(params, inv_id).then(resp => {
						resolve(resp.data);
					}).catch(err => {
						_gNotif.cLog(err);
						reject(err);
					});
				}).catch(err => {
					_gNotif.cLog(err);
					reject(err);
				});
			});
		},

		submitLoanEC(id) {
			if (_gHlp.isEmpty(id)) {
				id = _gHlp.getValue(this.activeLoanEC,'id')
			}
			const httpStore = useHttpStore();
			return new Promise((resolve, reject) => {
				if (!_gHlp.isEmpty(id)) {
					httpStore.post(`${services.invinity}loan-ec/submit/${id}`).then((resp) => {
						this.activeLoanEC = resp.data;
						resolve(resp.data);
					}).catch(err => {
						_gNotif.cLog(err);
						reject(err);
					});
				} else {
					reject(null);
				}
			});
		},

		rejectLoanEC(id) {
			if (_gHlp.isEmpty(id)) {
				id = _gHlp.getValue(this.activeLoanEC,'id')
			}
			const httpStore = useHttpStore();
			return new Promise((resolve, reject) => {
				if (!_gHlp.isEmpty(id)) {
					httpStore.post(`${services.invinity}loan-ec/reject/${id}`).then((resp) => {
						this.activeLoanEC = resp.data;
						resolve(resp.data);
					}).catch(err => {
						_gNotif.cLog(err);
						reject(err);
					});
				} else {
					reject(null);
				}
			});
		},

		appealLoanEC(id) {
			if (_gHlp.isEmpty(id)) {
				id = _gHlp.getValue(this.activeLoanEC,'id')
			}
			const httpStore = useHttpStore();
			return new Promise((resolve, reject) => {
				if (!_gHlp.isEmpty(id)) {
					httpStore.post(`${services.invinity}loan-ec/appeal/${id}`).then((resp) => {
						this.activeLoanEC = resp.data;
						resolve(resp.data);
					}).catch(err => {
						_gNotif.cLog(err);
						reject(err);
					});
				} else {
					reject(null);
				}
			});
		},

		approveLoanEC(id, finalData={}) {
			if (_gHlp.isEmpty(id)) {
				id = _gHlp.getValue(this.activeLoanEC,'id')
			}
			const httpStore = useHttpStore();
			return new Promise((resolve, reject) => {
				if (!_gHlp.isEmpty(id)) {
					httpStore.post(`${services.invinity}loan-ec/approve/${id}`, finalData).then((resp) => {
						this.activeLoanEC = resp.data;
						resolve(resp.data);
					}).catch(err => {
						_gNotif.cLog(err);
						reject(err);
					});
				} else {
					reject(null);
				}
			});
		},

		updateLoanEC(params, id = null) {
			const data = {
				...params
			}
			if(_gHlp.isEmpty(id)) id = _gHlp.getValue(this.activeLoanEC,'id')
			const httpStore = useHttpStore();
			return new Promise((resolve, reject) => {
				httpStore.put(`${services.invinity}loan-ec/${id}`, data).then((resp) => {
					this.activeLoanEC = resp.data?.data;
					resolve(resp.data);
				}).catch(err => {
					_gNotif.cLog(err);
					reject(err);
				});
			});
		},

		setFormLoanEc(newParams) {
			if (!_gHlp.isEmpty(newParams)) {
				this.activeFormLoanEc = {...this.activeFormLoanEc,...newParams}
			}
		},

		listOption() {
			const httpStore = useHttpStore();
			let loan_ec_id = _gHlp.getValue(this.activeLoanEC,'id');
			return new Promise((resolve, reject) => {
				if (!_gHlp.isEmpty(loan_ec_id)) {	
					httpStore.get(`${services.invinity}loan-ec/${loan_ec_id}/option`).then((resp) => {
						resolve(resp.data);
					}).catch(err => {
						_gNotif.cLog(err);
						reject(err);
					});
				}else{
					resolve([]);
				}
			});
		},

		createOrUpdateOption(data) {
			const httpStore = useHttpStore();
			let loan_ec_id = _gHlp.getValue(this.activeLoanEC,'id');
			return new Promise((resolve, reject) => {
				if (!_gHlp.isEmpty(loan_ec_id)) {	
					if (data.id) {
						httpStore.put(`${services.invinity}loan-ec/${loan_ec_id}/option/${data.id}`, data).then((resp) => {
							resolve(resp.data);
						}).catch(err => {
							_gNotif.cLog(err);
							reject(err);
						});
					} else {
						httpStore.post(`${services.invinity}loan-ec/${loan_ec_id}/option`, data).then((resp) => {
							resolve(resp.data);
						}).catch(err => {
							_gNotif.cLog(err);
							reject(err);
						});
					}
				}else{
					resolve([]);	
				}
			});
		},

		listRepayOption() {
			const httpStore = useHttpStore();
			let loan_ec_id = _gHlp.getValue(this.activeLoanEC,'id');
			return new Promise((resolve, reject) => {
				if (!_gHlp.isEmpty(loan_ec_id)) {	
					httpStore.get(`${services.invinity}loan-ec/${loan_ec_id}/repay-option`).then((resp) => {
						resolve(resp.data);
					}).catch(err => {
						_gNotif.cLog(err);
						reject(err);
					});
				}else{
					resolve([]);	
				}
			});
		},

		createOrUpdateRepayOption(data) {
			const httpStore = useHttpStore();
			let loan_ec_id = _gHlp.getValue(this.activeLoanEC,'id');
			return new Promise((resolve, reject) => {
				if (!_gHlp.isEmpty(loan_ec_id)) {	
					if (data.id) {
						httpStore.put(`${services.invinity}loan-ec/${loan_ec_id}/repay-option/${data.id}`, data).then((resp) => {
							resolve(resp.data);
						}).catch(err => {
							_gNotif.cLog(err);
							reject(err);
						});
					} else {
						httpStore.post(`${services.invinity}loan-ec/${loan_ec_id}/repay-option`, data).then((resp) => {
							resolve(resp.data);
						}).catch(err => {
							_gNotif.cLog(err);
							reject(err);
						});
					}
				}else{
					resolve([]);	
				}
			});
		},

		listOtherOption() {
			const httpStore = useHttpStore();
			let loan_ec_id = _gHlp.getValue(this.activeLoanEC,'id');
			return new Promise((resolve, reject) => {
				if (!_gHlp.isEmpty(loan_ec_id)) {	
					httpStore.get(`${services.invinity}loan-ec/${loan_ec_id}/other-option`).then((resp) => {
						resolve(resp.data);
					}).catch(err => {
						_gNotif.cLog(err);
						reject(err);
					});
				}else{
					resolve([]);	
				}
			});
		},

		createOrUpdateOtherOption(data) {
			const httpStore = useHttpStore();
			let loan_ec_id = _gHlp.getValue(this.activeLoanEC,'id');
			return new Promise((resolve, reject) => {
				if (!_gHlp.isEmpty(loan_ec_id)) {	
					if (data.id) {
						httpStore.put(`${services.invinity}loan-ec/${loan_ec_id}/other-option/${data.id}`, data).then((resp) => {
							resolve(resp.data);
						}).catch(err => {
							_gNotif.cLog(err);
							reject(err);
						});
					} else {
						httpStore.post(`${services.invinity}loan-ec/${loan_ec_id}/other-option`, data).then((resp) => {
							resolve(resp.data);
						}).catch(err => {
							_gNotif.cLog(err);
							reject(err);
						});
					}
				}else{
					resolve([]);	
				}
			});
		},

		generateDSR() {
			const httpStore = useHttpStore();
			return new Promise((resolve, reject) => {
				httpStore.get(`${services.customer}customer/${this.activeCustomerIm2u.customer_id}/dsr.generate`).then((resp) => {
					this.activeCustomerIm2u = res.data.data
					this.getActiveCustomer
					resolve(this.activeCustomerIm2u)
				}).catch(err => {
					_gNotif.cLog(err);
					reject(err);
				});
			});
		},

		/*=OTHER PAYMENTS=*/
		getOtherPaymentList() {
			this.activeLoanECOtherPayment = [];
			const httpStore = useHttpStore();
			let loan_ec_id = _gHlp.getValue(this.activeLoanEC,'id');
			return new Promise((resolve, reject) => {
				if (!_gHlp.isEmpty(loan_ec_id)) {	
					let params = _gHlp.generateQueryParams({ paginate: 'no_paginate' })
					httpStore.get(`${services.invinity}loan-ec/${loan_ec_id}/other-payment?${params}`).then((resp) => {
						this.activeLoanECOtherPayment = resp.data
						resolve(resp.data);
					}).catch(err => {
						_gNotif.cLog(err);
						reject(err);
					});
				}else{
					resolve([]);	
				}
			});
		},

		createOrUpdateOtherPayment(data) {
			const httpStore = useHttpStore();
			let loan_ec_id = _gHlp.getValue(this.activeLoanEC,'id');
			return new Promise((resolve, reject) => {
				if (!_gHlp.isEmpty(loan_ec_id)) {	
					if (data.id) {
						httpStore.put(`${services.invinity}loan-ec/${loan_ec_id}/other-payment/${data.id}`, data).then((resp) => {
							resolve(resp.data);
						}).catch(err => {
							_gNotif.cLog(err);
							reject(err);
						});
					} else {
						httpStore.post(`${services.invinity}loan-ec/${loan_ec_id}/other-payment`, data).then((resp) => {
							resolve(resp.data);
						}).catch(err => {
							_gNotif.cLog(err);
							reject(err);
						});
					}
				}else{
					resolve([]);	
				}
			});
		},

		deleteOtherPayment(id) {
			const httpStore = useHttpStore();
			let loan_ec_id = _gHlp.getValue(this.activeLoanEC,'id');
			return new Promise((resolve, reject) => {
				if (!_gHlp.isEmpty(loan_ec_id)) {	
					httpStore.delete(`${services.invinity}loan-ec/${loan_ec_id}/other-payment/${id}`).then((resp) => {
						resolve(resp.data);
					}).catch(err => {
						_gNotif.cLog(err);
						reject(err);
					});
				}else{
					resolve([]);	
				}
			});
		},

		/*=REPAYMENT SOURCES=*/
		getProposedRepaymentList() {
			this.activeLoanECRepaymentSrc = [];
			const httpStore = useHttpStore();
			let loan_ec_id = _gHlp.getValue(this.activeLoanEC,'id');
			return new Promise((resolve, reject) => {
				if (!_gHlp.isEmpty(loan_ec_id)) {	
					let params = _gHlp.generateQueryParams({ paginate: 'no_paginate' })
					httpStore.get(`${services.invinity}loan-ec/${loan_ec_id}/proposed-repayment?${params}`).then((resp) => {
						this.activeLoanECRepaymentSrc = resp.data
						resolve(resp.data);
					}).catch(err => {
						_gNotif.cLog(err);
						reject(err);
					});
				}else{
					resolve([]);	
				}
			});
		},

		createOrUpdateProposedRepayment(data) {
			const httpStore = useHttpStore();
			let loan_ec_id = _gHlp.getValue(this.activeLoanEC,'id');
			return new Promise((resolve, reject) => {
				if (!_gHlp.isEmpty(loan_ec_id)) {	
					if (data.id) {
						httpStore.put(`${services.invinity}loan-ec/${loan_ec_id}/proposed-repayment/${data.id}`, data).then((resp) => {
							resolve(resp.data);
						}).catch(err => {
							_gNotif.cLog(err);
							reject(err);
						});
					} else {
						httpStore.post(`${services.invinity}loan-ec/${loan_ec_id}/proposed-repayment`, data).then((resp) => {
							resolve(resp.data);
						}).catch(err => {
							_gNotif.cLog(err);
							reject(err);
						});
					}
				}else{
					resolve([]);	
				}
			});
		},

		deleteProposedRepayment(id) {
			const httpStore = useHttpStore();
			let loan_ec_id = _gHlp.getValue(this.activeLoanEC,'id');
			return new Promise((resolve, reject) => {
				if (!_gHlp.isEmpty(loan_ec_id)) {	
					httpStore.delete(`${services.invinity}loan-ec/${loan_ec_id}/proposed-repayment/${id}`).then((resp) => {
						resolve(resp.data);
					}).catch(err => {
						_gNotif.cLog(err);
						reject(err);
					});
				}else{
					resolve([]);	
				}
			});
		},

		/*=CCRIS COMMITMENTS=*/
		getCCRISCommitmentList() {
			this.activeLoanECCcriss = [];
			const httpStore = useHttpStore();
			let loan_ec_id = _gHlp.getValue(this.activeLoanEC,'id');
			return new Promise((resolve, reject) => {
				if (!_gHlp.isEmpty(loan_ec_id)) {	
					let params = _gHlp.generateQueryParams({ paginate: 'no_paginate' })
					httpStore.get(`${services.invinity}loan-ec/${loan_ec_id}/ccris-items?${params}`).then((resp) => {
						this.activeLoanECCcriss = resp.data;
						resolve(resp.data);
					}).catch(err => {
						_gNotif.cLog(err);
						reject(err);
					});
				}else{
					resolve([]);	
				}
			});
		},
		createOrUpdateCCRISItems(data) {
			const httpStore = useHttpStore();
			let loan_ec_id = _gHlp.getValue(this.activeLoanEC,'id');
			return new Promise((resolve, reject) => {
				if (!_gHlp.isEmpty(loan_ec_id)) {	
					if (data.id) {
						httpStore.put(`${services.invinity}loan-ec/${loan_ec_id}/ccris-items/${data.id}`, data).then((resp) => {
							resolve(resp.data);
						}).catch(err => {
							_gNotif.cLog(err);
							reject(err);
						});
					} else {
						httpStore.post(`${services.invinity}loan-ec/${loan_ec_id}/ccris-items`, data).then((resp) => {
							resolve(resp.data);
						}).catch(err => {
							_gNotif.cLog(err);
							reject(err);
						});
					}
				}else{
					resolve([]);	
				}
			});
		},
		/*=NON CCRIS COMMITMENTS=*/
		getNonCCRISCommitmentList() {
			this.activeLoanECNonCcriss = [];
			const httpStore = useHttpStore();
			let loan_ec_id = _gHlp.getValue(this.activeLoanEC,'id');
			return new Promise((resolve, reject) => {
				if (!_gHlp.isEmpty(loan_ec_id)) {	
					let params = _gHlp.generateQueryParams({ paginate: 'no_paginate' })
					httpStore.get(`${services.invinity}loan-ec/${loan_ec_id}/non-ccris-items?${params}`).then((resp) => {
						this.activeLoanECNonCcriss = resp.data;
						resolve(resp.data);
					}).catch(err => {
						_gNotif.cLog(err);
						reject(err);
					});
				}else{
					resolve([]);	
				}
			});
		},
		createOrUpdateNonCCRISItems(data) {
			const httpStore = useHttpStore();
			let loan_ec_id = _gHlp.getValue(this.activeLoanEC,'id');
			return new Promise((resolve, reject) => {
				if (!_gHlp.isEmpty(loan_ec_id)) {	
					if (data.id) {
						httpStore.put(`${services.invinity}loan-ec/${loan_ec_id}/non-ccris-items/${data.id}`, data).then((resp) => {
							resolve(resp.data);
						}).catch(err => {
							_gNotif.cLog(err);
							reject(err);
						});
					} else {
						httpStore.post(`${services.invinity}loan-ec/${loan_ec_id}/non-ccris-items`, data).then((resp) => {
							resolve(resp.data);
						}).catch(err => {
							_gNotif.cLog(err);
							reject(err);
						});
					}
				}else{
					resolve([]);	
				}
			});
		},
		deleteNonCCRISItems(id) {
			const httpStore = useHttpStore();
			let loan_ec_id = _gHlp.getValue(this.activeLoanEC,'id');
			return new Promise((resolve, reject) => {
				if (!_gHlp.isEmpty(loan_ec_id)) {	
					httpStore.delete(`${services.invinity}loan-ec/${loan_ec_id}/non-ccris-items/${id}`).then((resp) => {
						resolve(resp.data);
					}).catch(err => {
						_gNotif.cLog(err);
						reject(err);
					});
				}else{
					resolve([]);	
				}
			});
		},


		getGroupMessage(params) {
			const httpStore = useHttpStore();
			return new Promise((resolve, reject) => {
				httpStore.get(`${services.messaging}group-messages`, params).then((resp) => {
					resolve(resp.data);
				}).catch(err => {
					_gNotif.cLog(err);
					reject(err);
				});
			});
		},

		postGroupMessage(params) {
			const httpStore = useHttpStore();
			return new Promise((resolve, reject) => {
				httpStore.post(`${services.messaging}group-messages`, params).then((resp) => {
					resolve(resp.data);
				}).catch(err => {
					_gNotif.cLog(err);
					reject(err);
				});
			});
		},

		getActivityLogList(params = {}) {
			const httpStore = useHttpStore();
			return new Promise((resolve, reject) => {
				httpStore.get(`${services.invinity}activity-log`, params).then((resp) => {
					httpStore.convertPaginationKeys(resp.data);
					resolve(resp.data);
				})
			});
		},
	}
})